import classNames from 'classnames';
import React, { Component, Fragment } from 'react';

import { getPlansByCommitmentLevel, isPlanAvailable } from 'utils/stripePlanUtils';

import 'pages/student/Activate/ActivateSubscription/style.css';
import '../style.css';

class UpdatePlan extends Component {
  handlePlanClick = (availablePlan) => {
    this.props.onPlanSelect(availablePlan);
  }

  renderHeader() {
    const { stripePlan, trialStatus } = this.props;
    if (trialStatus && trialStatus.status === 'credit_trial') {
      if (trialStatus.creditsRemaining === 0) {
        return (
          <h6>
            <strong>Your trial is complete. Please select a plan below.</strong>
          </h6>
        );
      }
      return (
        <h6>
          You have{' '}
          <strong>
            {trialStatus.unusedCredits} trial credit
            {trialStatus.unusedCredits === 1 ? '' : 's'}
          </strong>{' '}
          remaining. You may choose a plan below to end your trial. You will not
          lose purchased credits.
        </h6>
      );
    }
    if (!stripePlan) {
      return <h6 style={{ color: 'red' }}>You have no subscription</h6>;
    }
    const isPlanCurrentlyOffered = isPlanAvailable(stripePlan);
    if (!isPlanCurrentlyOffered) {
      return <h6 style={{ color: 'red' }}>You have an old plan</h6>;
    }
    return null;
  }

  renderPlan(availablePlan) {
    return (
      <div
        key={availablePlan.id}
        onClick={() => this.handlePlanClick(availablePlan)}
        className="col"
      >
        <div
          className={classNames(
            'period-select__content btn-cursor d-flex align-items-center justify-content-center',
            {
              'period-select__content--select': availablePlan.id === this.props.selectedPlan.id
            }
          )}
        >
          <div className="d-inline-block text-center">
            <h6 className="period-select__title">{availablePlan.limit} hours</h6>
            <p className="period-select__sub-title mb-0">per month</p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { selectedPlan } = this.props;
    const filteredPlansByCommitmentLevel = getPlansByCommitmentLevel(selectedPlan);
    return (
      (
        <Fragment>
          {this.renderHeader()}
          <h5 className="mb-4 mt-4">Plans</h5>
          <div className="period-select row">
            {filteredPlansByCommitmentLevel.map(plan => this.renderPlan(plan))}
          </div>
          <h5 className="mb-4 mt-4">Billing Period</h5>
          <div className="period-select">
            {this.props.children}
          </div>
        </Fragment>
      )
    );
  }
}

export default UpdatePlan;



// WEBPACK FOOTER //
// ./src/components/PlanSelect/UpdatePlan/index.js